import { UseSWROutput, useSWR } from '~/hooks/useSWR';
import { AnniversaryReadApiClient, People } from '~/services/Http';

import { AnniversaryTypeEnum } from '../../client.people.generated';

export const GET_TEAM_ANNIVERSARIES_SWR_KEY =
  'AnniversaryReadApiClient.getTeamAnniversaries';

export function useGetTeamAnniversaries(args: {
  employeeId: string;
  lang?: string | undefined;
  startDate?: string | undefined;
  endDate?: string | undefined;
  order?: People.Order17;
  treeId?: string | undefined;
  types?: AnniversaryTypeEnum[] | undefined;
  roles?: string[];
  unitIds?: number[] | undefined;
}): UseSWROutput<People.AnniversaryDto[]> {
  return useSWR(
    [
      GET_TEAM_ANNIVERSARIES_SWR_KEY,
      args.employeeId,
      args?.lang ?? undefined,
      args?.startDate ?? undefined,
      args?.endDate ?? undefined,
      args?.order ?? undefined,
      args?.treeId ?? undefined,
      args?.types ?? undefined,
      args?.unitIds ?? undefined,
      args?.roles ?? undefined,
    ],
    ([
      _,
      employeeId,
      lang,
      startDate,
      endDate,
      order,
      treeId,
      types,
      unitIds,
      roles,
    ]) =>
      AnniversaryReadApiClient.getTeamAnniversaries(
        employeeId,
        order,
        startDate,
        endDate,
        lang,
        treeId,
        types,
        roles,
        unitIds,
      ).then((r) => r.data),
  );
}
